import { Flex } from "@chakra-ui/react"
import * as React from "react"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import layoutStates from "../../../recoil/atoms/layout"
import { ChatList } from "./_chatList"
import {
  bottomMostUnreadAtom,
  chatAttachmentDataAtom,
  chatScrollStateAtom,
  topMostUnreadAtom
} from "../../../recoil/atoms/chats"
import { Icon } from "../../common/icons"
import { VscArrowDown } from "react-icons/vsc"
import styled from "@emotion/styled"
import { ChatStyles } from "./index"
interface ChatScreenProps {
  selectedPollsLength: number
  screenRef: React.RefObject<HTMLDivElement>
  styleschat: ChatStyles
  canSendChat: boolean
  chatApprovalRequired: boolean
}

interface StyledProps {
  styleschat?: ChatStyles
}

const Container = styled(Flex)<StyledProps>`
  &::-webkit-scrollbar-track {
    background: ${({ styleschat }) =>
      styleschat.servicePanelElementBorder || "#cbd5e0"};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ styleschat }) =>
      styleschat.servicePanelElementBorderOffset || "#fff"};
    border-radius: 10px;
    height: 5px;
    max-height: 10px;
  }
`

export const _ChatScreen: React.FC<ChatScreenProps> = ({
  selectedPollsLength,
  screenRef,
  styleschat,
  chatApprovalRequired,
  canSendChat
}) => {
  const [chatMessageHeight] = useRecoilState(layoutStates.chatMessageHeight)
  const heightChat = `calc(100vh - ${chatMessageHeight}px - 2rem)`
  const bottomMostUnread = useRecoilValue(bottomMostUnreadAtom)
  const topMostUnread = useRecoilValue(topMostUnreadAtom)
  const setChatScrollState = useSetRecoilState(chatScrollStateAtom)
  const attachment = useRecoilValue(chatAttachmentDataAtom)
  const hasAttachment = !!attachment.data.length

  const [isOneTab] = useRecoilState<boolean>(layoutStates.isOneTab)

  const handleGoUp = React.useCallback(() => {
    setChatScrollState("UP")
  }, [setChatScrollState])

  const handleGoDown = React.useCallback(() => {
    setChatScrollState("DOWN")
  }, [setChatScrollState])

  return (
    <Container
      styleschat={styleschat}
      flexDirection="column"
      id={"messages-container"}
      flex={1}
      ref={screenRef}
      // w="100%"
      marginTop="1rem"
      marginBottom={hasAttachment ? "1rem" : "0"}
      paddingLeft="1rem"
      paddingRight="0.5rem"
      marginRight="0.5rem"
      paddingTop={selectedPollsLength > 0 && "0"}
      overflowX="hidden"
      overflowY="auto"
      scrollbarwidth="thin"
      style={{ scrollBehavior: "smooth" }}
      height={heightChat}
    >
      <ChatList
        chatApprovalRequired={chatApprovalRequired}
        styleschat={styleschat}
        canSendChat={canSendChat}
      />
      <Flex>
        {topMostUnread && (
          <Flex
            cursor="pointer"
            zIndex={1}
            onClick={handleGoUp}
            left={isOneTab ? "47%" : "35%"}
            bg={styleschat.secondaryAccessButtonBackgroundColor ?? "gray.400"}
            pos="absolute"
            borderRadius="50%"
            justifyContent="center"
            alignContent="center"
            opacity="0.75"
            top={"35px"}
            transform={"rotate(180deg)"}
          >
            <Icon
              src={VscArrowDown}
              fontSize={"2rem"}
              padding="3px"
              color={styleschat.secondaryAccessButtonTextColor ?? "white"}
            />
          </Flex>
        )}

        {bottomMostUnread && (
          <Flex
            cursor="pointer"
            zIndex={1000000000}
            onClick={handleGoDown}
            left={isOneTab ? "47%" : "35%"}
            bg={styleschat.secondaryAccessButtonBackgroundColor ?? "gray.400"}
            pos="absolute"
            borderRadius="50%"
            justifyContent="center"
            alignContent="center"
            opacity="0.75"
            bottom={"80px"}
            transform={"unset"}
          >
            <Icon
              src={VscArrowDown}
              fontSize={"2rem"}
              padding="3px"
              color={styleschat.secondaryAccessButtonTextColor ?? "white"}
            />
          </Flex>
        )}
      </Flex>
    </Container>
  )
}

export const ChatScreen = React.memo(_ChatScreen)
